const getTitle = (title: string, charLimit: number): string => {
  return title.length > charLimit ? `${title.substring(0, charLimit)}...` : title;
};

export default getTitle;
